module.exports = __webpack_public_path__ + "img/sist-logo.43fb97f2.png";